import { RequestWithContent } from './RequestWithContent'
import type { Request } from './Request'

export class PostRequest<T, D> extends RequestWithContent<T, D> {
  public constructor(origin: Request<T>, content: D) {
    super(origin, content)
    this.requestMessage.method = 'post'
  }
}
